export default __webpack_public_path__ + "static/media/ajc.14f68935.webp";